import React from 'react';

import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import { useLoadingIndicatorContext } from './LoadingIndicatorProvider';

const useStyles = makeStyles((theme) => ({
  modal: {
    zIndex: 1350, // Our alerts are at 1400 and dialogs are at 1300, so keep it between those
  },
  processingDialog: {
    zIndex: '1350 !important',
    '& .MuiDialog-paper': {
      width: 'calc(100% - 36px)',
      maxWidth: '460px',
      padding: '30px',
      textAlign: 'center',
    },
  },
  processingContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  processingTitle: {
    marginTop: '20px',
    color: theme.palette.darkGray.main,
    fontSize: '20px',
    lineHeight: '28px',
    fontWeight: 700,
  },
  processingMessage: {
    maxWidth: '380px',
    marginTop: '10px',
    color: theme.palette.lightGray.main,
    fontSize: '15px',
    lineHeight: '23px',
  },
  inline: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    width: '100%',
    height: '100%',
  },
}));

export default function LoadingIndicator({ modal = false, color = '', ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const loadingIndicatorContext = useLoadingIndicatorContext();
  const modalContent = loadingIndicatorContext?.loadingIndicatorModalContent;

  if (!modal) {
    return (
      <div
        className={classes.inline}
        style={{ color: color || theme.palette.gray.main }}
      >
        <CircularProgress color="inherit" {...props} />
      </div>
    );
  }

  if (modalContent) {
    return (
      <Dialog
        open
        disableBackdropClick
        disableEscapeKeyDown
        className={classes.processingDialog}
        aria-labelledby="loading-indicator-title"
        aria-describedby="loading-indicator-message"
      >
        <div
          className={classes.processingContent}
          role="alert"
          aria-live="assertive"
        >
          <CircularProgress
            color="inherit"
            style={{ color: color || theme.palette.primary.main }}
            {...props}
          />
          <div id="loading-indicator-title" className={classes.processingTitle}>
            {modalContent.title}
          </div>
          <div id="loading-indicator-message" className={classes.processingMessage}>
            {modalContent.message}
          </div>
        </div>
      </Dialog>
    );
  }

  return (
    <Backdrop open className={classes.modal} style={{ color: color || theme.palette.gray.main }}>
      <CircularProgress color="inherit" {...props} />
    </Backdrop>
  );
}
